<template>
    <div class="calendar-head component">
      <template v-if="windowWidth > mobileWidth">
        <div v-for="(date, idx) in weekDisplay" :key="idx" class="calender-head-item" :class="{ disabled: !date.active, active: date.date === selectDate }" @click="onDateClick(date.date)">
          <div>
            <p class="day-of-week">{{ dayOfWeek(date.date) }}</p>
            <p class="date">{{ dateDisplay(date.date) }}</p>
          </div>
        </div>
        <button class="previous" v-if="weekIndex>0" @click="weekIndexChange('reduction')"><i class="chevron chevron-left"></i></button>
        <button class="next" @click="weekIndexChange('add')"><i class="chevron chevron-right"></i></button>
      </template>
      <template v-else>
        <swiper class="swiper" :options="swiperOption">
          <swiper-slide v-for="(date, idx) in monthDisplay" :key="idx">
            <div class="calender-head-item" :class="{ disabled: !date.active, active: date.date === selectDate }" @click="onDateClick(date.date)">
              <div>
                <p class="day-of-week">{{ dayOfWeek(date.date) }}</p>
                <p class="date">{{ dateDisplay(date.date) }}</p>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
      </template>
    </div>
  </template>
  
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import moment from 'moment'
export default {
  name: 'CalendarHead',
  props: {
    windowWidth: { type: Number },
    parentDateClickHandler: { type: Function }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      weekIndex: 0,
      selectDate: '',
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 0,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  watch: {
    weekIndex: function (val) {
      this.calSelectDate()
    }
  },
  computed: {
    today () {
      return moment().format('YYYY-MM-DD')
    },
    weekDisplay () {
      const from_date = moment(this.today).utc().zone(-9).add(7 * this.weekIndex, 'days')
      const week = []
      for (let i = 0; i < 7; i++) {
        week.push({
          date: from_date.format('YYYY-MM-DD'),
          active: true
        })
        from_date.add(1, 'days')
      }
      return week
    },
    monthDisplay () {
      const from_date = moment(this.today).utc().zone(-9)
      const month = []
      for (let i = 0; i < 31; i++) {
        month.push({
          date: from_date.format('YYYY-MM-DD'),
          active: true
        })
        from_date.add(1, 'days')
      }
      return month
    },
    mobileWidth () {
      return this.$store.state.dom.widthSmall
    }
  },
  methods: {
    dayOfWeek (dateStr) {
      const _dayOfWeek = moment(dateStr).utc().zone(-9).format('dddd').toLowerCase()
      return this.$i18n.messages[this.$i18n.fallbackLocale].dayOfWeek[_dayOfWeek]
    },
    dateDisplay (dateStr) {
      return moment(dateStr).utc().zone(-9).format('MM/DD')
    },
    weekIndexChange (type = 'add') {
      let newWeekIndex = this.weekIndex
  
      if (type === 'add') {
        newWeekIndex++
      } else {
        newWeekIndex--
      }
  
      this.weekIndex = newWeekIndex
    },
    calSelectDate () {
      const curDay = this.weekDisplay[0].date
  
      this.onDateClick(curDay)
      this.selectDate = curDay
    },
    onDateClick (dateStr) {
      if (dateStr !== this.selectDate) {
        this.selectDate = dateStr
        this.$emit('onDateClick')
        this.parentDateClickHandler(this.selectDate)
      }
    }
  },
  mounted () {
  },
  created () {
    this.calSelectDate()
  }
}
</script>
  
  <style lang="scss" scoped>
    .calendar-head {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      padding: 0 50px;
  
      .swiper-slide {
        max-width: 25%;
      }
  
      .swiper-scrollbar {
        background: var(--Background-color);
      }
  
      .calender-head-item {
        width: calc(100% / 7);
        padding: 8px;
        text-align: center;
        transform: skewX(-15deg);
  
        &:hover {
          cursor: pointer;
        }
  
        > * {
          transform: skewX(15deg);
        }
  
        .day-of-week {
          font-size: 16px;
          font-weight: 500;
          line-height: normal;
          letter-spacing: 0.72px;
  
          @include media_mobile {
            font-size: 14px;
            letter-spacing: 0.54px;
          }
        }
  
        .date {
          font-size: 20px;
          font-weight: 500;
          line-height: normal;
          letter-spacing: 0.9px;
  
          @include media_mobile {
            font-size: 16px;
            letter-spacing: 0.63px;
          }
        }
  
        p + p {
          margin-top: 10px;
  
          @include media_mobile {
            margin-top: 0;
          }
        }
  
        &.disabled {
          pointer-events: none;
  
          p {
            color: var(--Secondary-font-color);
          }
        }
  
        &.active {
          background-color: var(--Main-color);
  
          p {
            color: $color-white-1;
          }
        }
  
        @include media_mobile {
          width: 80%;
          margin: auto;
        }
      }
  
      button {
        position: absolute;
        width: 26px;
        height: 26px;
        border: 0 solid;
        border-radius: 26px;
        background-color: $color-grey-7;
  
        &:hover {
          cursor: pointer;
        }
  
        &.previous {
          left: 15px;
        }
  
        &.next {
          right: 15px;
        }
  
        .chevron {
          border-right: 1px solid $color-black-1;
          border-bottom: 1px solid $color-black-1;
        }
      }
  
      @include media_mobile {
        flex-wrap: wrap;
        justify-content: center;
        padding: 0 17px;
      }
    }
  </style>
